export default __webpack_public_path__ + "c324143ce3f4b238952ad7a9a9338c60.svg";